export default "__VITE_ASSET__CRRhdj4O__"